import {
  BooleanField,
  DateField,
  Labeled,
  ReferenceField,
  SelectField,
  TextField,
  useShowController,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { GenderOptionsId } from "utils/choices";
import { MobilityVisitType } from "utils/constants";
import DocumentFileLink from "../../Partials/DocumentFileLink";

const ShowView = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { record } = useShowController();

  return (
    <>
      <Grid
        container
        spacing={2}
        p={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Данни за кандидата"
            paddingY={0}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Имe (кирилица)">
            <TextField
              source="firstNameCyrillic"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Фамилия (кирилица)">
            <TextField
              source="lastNameCyrillic"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Имe (латиница)">
            <TextField
              source="firstNameLatin"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Фамилия (латиница)">
            <TextField
              source="lastNameLatin"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Имейл">
            <TextField
              source="email"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Телефон">
            <TextField
              source="phoneNumber"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Пол">
            <SelectField
              source="gender"
              choices={GenderOptionsId}
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Длъжност">
            <TextField
              source="position"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Тип Гражданство ЕС / Извън ЕС">
            <ReferenceField
              source="citizenship"
              reference={administrationRequests.getCitizenshipSelect()}
            >
              <TextField
                source="name"
                emptyText="-"
              />
            </ReferenceField>
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Тип визита">
            <ReferenceField
              source="mobilityVisitType"
              reference={erasmusRequests.getMobilityTypesSelect()}
            >
              <TextField
                source="nameBg"
                emptyText="-"
              />
            </ReferenceField>
          </Labeled>
        </Grid>

        {record?.mobilityVisitType === MobilityVisitType.BIP && (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="BIP имe">
                <TextField
                  source="bipName"
                  emptyText="-"
                />
              </Labeled>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="BIP номер">
                <TextField
                  source="bipNumber"
                  emptyText="-"
                />
              </Labeled>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Начална дата">
                <DateField
                  source="startDate"
                  locales="bg-BG"
                  emptyText="-"
                />
              </Labeled>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Крайна дата">
                <DateField
                  source="endDate"
                  locales="bg-BG"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
          </>
        )}

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Университет">
            <ReferenceField
              source="universityId"
              reference={administrationRequests.getUniversitiesSelect()}
            >
              <TextField
                source="name"
                emptyText="-"
              />
            </ReferenceField>
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Структурна единица">
            <ReferenceField
              source="structuralUnitId"
              reference={administrationRequests.getStructuralUnitsSelect()}
            >
              <TextField
                source="name"
                emptyText="-"
              />
            </ReferenceField>
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Факултет">
            <ReferenceField
              source="specialtyId"
              reference={administrationRequests.getSpecialitiesSelect()}
            >
              <TextField
                source="name"
                emptyText="-"
              />
            </ReferenceField>
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Желае общежитие">
            <BooleanField
              source="wantsDormitory"
              sx={{ width: "fit-content" }}
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Приключил">
            <BooleanField
              source="isCompleted"
              sx={{ width: "fit-content" }}
            />
          </Labeled>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        p={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Документи"
            paddingY={0}
          />
        </Grid>

        {record?.mobilityAgreementId && (
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Споразумение за мобилност">
              <DocumentFileLink
                id={record.mobilityAgreementId}
                documentName="Споразумение за мобилност"
              />
            </Labeled>
          </Grid>
        )}

        {record?.acceptanceLetterId && (
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Писмо за приемане">
              <DocumentFileLink
                id={record.acceptanceLetterId}
                documentName="Писмо за приемане"
              />
            </Labeled>
          </Grid>
        )}

        {record?.cvId && (
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="CV">
              <DocumentFileLink
                id={record.cvId}
                documentName="CV"
              />
            </Labeled>
          </Grid>
        )}
      </Grid>

      <Grid
        container
        spacing={2}
        p={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Одит"
            paddingY={0}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Създал">
            <TextField
              source="createdByName"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Създадено на">
            <DateField
              source="createdOn"
              locales="bg-BG"
              showTime
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Променил">
            <TextField
              source="updatedByName"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Променено на">
            <DateField
              source="updatedOn"
              locales="bg-BG"
              showTime
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default ShowView;
